module.exports = __webpack_public_path__ + "img/ic_burger_teams-active.a333e36f.svg";